module.exports = __webpack_public_path__ + "static/media/duplicate.0beb885a.svg";